/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StartImport } from './routes/start'
import { Route as PasswordresetLayoutImport } from './routes/_passwordreset-layout'
import { Route as StartIndexImport } from './routes/start.index'
import { Route as SSurveyIdImport } from './routes/s/$surveyId'
import { Route as PasswordresetLayoutPasswordresetIndexImport } from './routes/_passwordreset-layout/passwordreset/index'
import { Route as PasswordresetLayoutResetDoneImport } from './routes/_passwordreset-layout/reset/done'
import { Route as PasswordresetLayoutPasswordresetDoneImport } from './routes/_passwordreset-layout/passwordreset/done'
import { Route as PasswordresetLayoutResetUidb64SetPasswordImport } from './routes/_passwordreset-layout/reset/$uidb64.set-password'
import { Route as PasswordresetLayoutResetUidb64TokenImport } from './routes/_passwordreset-layout/reset/$uidb64.$token'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const StartRoute = StartImport.update({
  path: '/start',
  getParentRoute: () => rootRoute,
} as any)

const PasswordresetLayoutRoute = PasswordresetLayoutImport.update({
  id: '/_passwordreset-layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const StartIndexRoute = StartIndexImport.update({
  path: '/',
  getParentRoute: () => StartRoute,
} as any)

const SSurveyIdRoute = SSurveyIdImport.update({
  path: '/s/$surveyId',
  getParentRoute: () => rootRoute,
} as any)

const PasswordresetLayoutPasswordresetIndexRoute =
  PasswordresetLayoutPasswordresetIndexImport.update({
    path: '/passwordreset/',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutResetDoneRoute =
  PasswordresetLayoutResetDoneImport.update({
    path: '/reset/done',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutPasswordresetDoneRoute =
  PasswordresetLayoutPasswordresetDoneImport.update({
    path: '/passwordreset/done',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutResetUidb64SetPasswordRoute =
  PasswordresetLayoutResetUidb64SetPasswordImport.update({
    path: '/reset/$uidb64/set-password',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutResetUidb64TokenRoute =
  PasswordresetLayoutResetUidb64TokenImport.update({
    path: '/reset/$uidb64/$token',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_passwordreset-layout': {
      id: '/_passwordreset-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PasswordresetLayoutImport
      parentRoute: typeof rootRoute
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartImport
      parentRoute: typeof rootRoute
    }
    '/s/$surveyId': {
      id: '/s/$surveyId'
      path: '/s/$surveyId'
      fullPath: '/s/$surveyId'
      preLoaderRoute: typeof SSurveyIdImport
      parentRoute: typeof rootRoute
    }
    '/start/': {
      id: '/start/'
      path: '/'
      fullPath: '/start/'
      preLoaderRoute: typeof StartIndexImport
      parentRoute: typeof StartImport
    }
    '/_passwordreset-layout/passwordreset/done': {
      id: '/_passwordreset-layout/passwordreset/done'
      path: '/passwordreset/done'
      fullPath: '/passwordreset/done'
      preLoaderRoute: typeof PasswordresetLayoutPasswordresetDoneImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_passwordreset-layout/reset/done': {
      id: '/_passwordreset-layout/reset/done'
      path: '/reset/done'
      fullPath: '/reset/done'
      preLoaderRoute: typeof PasswordresetLayoutResetDoneImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_passwordreset-layout/passwordreset/': {
      id: '/_passwordreset-layout/passwordreset/'
      path: '/passwordreset'
      fullPath: '/passwordreset'
      preLoaderRoute: typeof PasswordresetLayoutPasswordresetIndexImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_passwordreset-layout/reset/$uidb64/$token': {
      id: '/_passwordreset-layout/reset/$uidb64/$token'
      path: '/reset/$uidb64/$token'
      fullPath: '/reset/$uidb64/$token'
      preLoaderRoute: typeof PasswordresetLayoutResetUidb64TokenImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_passwordreset-layout/reset/$uidb64/set-password': {
      id: '/_passwordreset-layout/reset/$uidb64/set-password'
      path: '/reset/$uidb64/set-password'
      fullPath: '/reset/$uidb64/set-password'
      preLoaderRoute: typeof PasswordresetLayoutResetUidb64SetPasswordImport
      parentRoute: typeof PasswordresetLayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  PasswordresetLayoutRoute: PasswordresetLayoutRoute.addChildren({
    PasswordresetLayoutPasswordresetDoneRoute,
    PasswordresetLayoutResetDoneRoute,
    PasswordresetLayoutPasswordresetIndexRoute,
    PasswordresetLayoutResetUidb64TokenRoute,
    PasswordresetLayoutResetUidb64SetPasswordRoute,
  }),
  StartRoute: StartRoute.addChildren({ StartIndexRoute }),
  SSurveyIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_passwordreset-layout",
        "/start",
        "/s/$surveyId"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/_passwordreset-layout": {
      "filePath": "_passwordreset-layout.tsx",
      "children": [
        "/_passwordreset-layout/passwordreset/done",
        "/_passwordreset-layout/reset/done",
        "/_passwordreset-layout/passwordreset/",
        "/_passwordreset-layout/reset/$uidb64/$token",
        "/_passwordreset-layout/reset/$uidb64/set-password"
      ]
    },
    "/start": {
      "filePath": "start.tsx",
      "children": [
        "/start/"
      ]
    },
    "/s/$surveyId": {
      "filePath": "s/$surveyId.tsx"
    },
    "/start/": {
      "filePath": "start.index.tsx",
      "parent": "/start"
    },
    "/_passwordreset-layout/passwordreset/done": {
      "filePath": "_passwordreset-layout/passwordreset/done.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_passwordreset-layout/reset/done": {
      "filePath": "_passwordreset-layout/reset/done.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_passwordreset-layout/passwordreset/": {
      "filePath": "_passwordreset-layout/passwordreset/index.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_passwordreset-layout/reset/$uidb64/$token": {
      "filePath": "_passwordreset-layout/reset/$uidb64.$token.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_passwordreset-layout/reset/$uidb64/set-password": {
      "filePath": "_passwordreset-layout/reset/$uidb64.set-password.tsx",
      "parent": "/_passwordreset-layout"
    }
  }
}
ROUTE_MANIFEST_END */
